import React, { useEffect, useState } from 'react'
import { Button, message, Modal } from 'antd'
import { EditOutlined, DeleteOutlined, ExportOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import MainTable from '../../../components/Basic/MainTable'
import { useLocation, useNavigate } from 'react-router-dom'
import { delCriteria, fetchCriteria } from '../../../apis/segment'
import { fetchSources } from '../../../apis/source'
import { useSelector } from 'react-redux'

function Criteria (props) {
  const { params, formatDate, viewOnly } = props
  const { t: ln_t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { state, pathname } = location || {}
  const { type = 'criteria' } = state || {}
  const user = useSelector((state) => state.user)
  const { groups, nowGroup } = user || {}
  const { handleFetchParams, fetchParams } = params
  const [typeOptions, setTypeOptions] = useState([])

  const handleDelete = (id, data) => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t(`segment.${type}`)}`,
      content: `${ln_t('message.confirm.delete')} ${data.name}?`,
      onOk: async () => {
        const result = await delCriteria(id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const apiFunc = async () => fetchCriteria(fetchParams)
  const columns = [
    { title: ln_t('criteria.name'), dataIndex: 'name', sorter: true },
    {
      title: ln_t('segment.type'),
      dataIndex: 'type',
      render: (e, data) => data?.dataSourceType?.name || '-',
      filters: typeOptions,
      filterMultiple: false
    },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', render: e => formatDate(e), sorter: true },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', render: e => formatDate(e, true), sorter: true },
    { title: ln_t('util.creator'), dataIndex: 'creator', render: e => e?.name || '-' },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, data) => (
        <div className="action-btn">
          {viewOnly
            ? <Button size="small" icon={<ExportOutlined />} onClick={() => navigate(`${pathname}/${type}/detail `, { state: { data } })}>{ln_t('segment.viewDetail')}</Button>
            : <>
                <Button size="small" icon={<EditOutlined />} onClick={() => navigate(`${pathname}/${type}/edit`, { state: { data } })} />
                <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(id, data)} />
              </>}
        </div>)
    }
  ]

  const fetchTypes = async () => {
    const availableSrc = groups?.find(i => i.id === nowGroup)?.dataSourceTypes?.split(',') || []
    const res = await fetchSources()
    if (res?.status === 200) {
      const type = res?.data?.filter(i => availableSrc.includes(`${i.id}`))?.map(({ id, name }) => ({ value: id, text: name }))
      setTypeOptions(type)
    }
  }
  useEffect(() => {
    fetchTypes()
  }, [])

  return (
    <MainTable
      columns={columns}
      rowKey="id"
      apiFunc={apiFunc}
      params={params}
      disabledRow={record => !record.previewCount || !record.status}
    />
  )
}

export default Criteria
